/**
 * Utility functions for guest invite feature.
 * Extracted for testability.
 */

/** Validate email format */
export const isValidEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
};

/** Format TTL hours for display */
export const formatTtlHours = (
  hours: number
): { days?: number; hours?: number } => {
  if (hours >= 24 && hours % 24 === 0) {
    return { days: hours / 24 };
  }
  return { hours };
};

/** Canonical temporary guest lifetimes, filtered by the server contract. */
export const buildTtlOptions = (min: number, max: number): number[] => {
  const presets = [24, 48, 72];
  return presets.filter(h => h >= min && h <= max);
};

/** Check if guest quota is full */
export const isGuestQuotaFull = (
  count: number | null,
  limit: number | null
): boolean => {
  if (count === null || limit === null) return false;
  if (limit < 0) return false; // unlimited
  return count >= limit;
};
